"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueSourceDropdown = exports.ValueSourceImageSelectedContainer = void 0;
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const elements_1 = require("./elements");
const WindowClicker = __importStar(require("../window-clicker"));
const ValueSourceDropdownRoot = styled_components_1.default.div `
  position: relative;
  display: inline-block;
  float: left;

  font-size: 12px;
  cursor: pointer;
  user-select: none;
`;
const ValueSourceDropdownOptionsContainer = styled_components_1.default.div `
  position: absolute;
  top: 100%;

  background: #fff;
  border: 1px solid #b4b4b4;
  z-index: 1001;
  padding: 1px;
  div {
    padding: 2px;

    display: flex;
    align-items: center;
    justify-content: left;

    &:hover {
      background-color: rgba(202, 229, 238, 1);
    }
  }
`;
exports.ValueSourceImageSelectedContainer = styled_components_1.default.div `
  border: 1px solid #b4b4b4;
  border-radius: 3px;
  padding: 3px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: left;
`;
class ValueSourceDropdown extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activated: false
        };
    }
    render() {
        const selected = this.props.options.find(o => o.value === this.props.selected);
        const { showCodes } = this.props;
        if (!selected) {
            return React.createElement(ValueSourceDropdownRoot, null, "not selected");
        }
        return (React.createElement(WindowClicker.Component, { onClick: () => this.setState({ activated: false }) },
            React.createElement(ValueSourceDropdownRoot, null,
                React.createElement(exports.ValueSourceImageSelectedContainer, { onClick: () => {
                        this.setState({
                            activated: true
                        });
                    } },
                    React.createElement(elements_1.ValueSourceImage, { src: selected.imageUrl }),
                    showCodes && React.createElement("span", null,
                        " (",
                        selected.value,
                        ")")),
                this.state.activated && (React.createElement(React.Fragment, null,
                    React.createElement(ValueSourceDropdownOptionsContainer, null, this.props.options.map(o => (React.createElement("div", { key: o.value, onClick: () => {
                            this.setState({ activated: false });
                            if (o.value === selected.value) {
                                return;
                            }
                            this.props.onChange(o.value);
                        } },
                        React.createElement(elements_1.ValueSourceImage, { src: o.imageUrl }),
                        showCodes && React.createElement("span", null,
                            " (",
                            o.value,
                            ")"))))))))));
    }
}
exports.ValueSourceDropdown = ValueSourceDropdown;
// export class ValueSourceDropdown extends React.Component<Props, State> {
//   constructor(props: Props) {
//     super(props);
//     this.state = {
//       activated: false
//     };
//   }
//   render(): JSX.Element {
//     const selected = this.props.options.find(
//       o => o.value === this.props.selected
//     );
//     if (!selected) {
//       return <ValueSourceDropdownRoot>not selected</ValueSourceDropdownRoot>;
//     }
//     return (
//       <ValueSourceDropdownRoot>
//         <ValueSourceImageSelectedContainer
//           onClick={e => {
//             e.stopPropagation();
//             this.setState({
//               activated: true
//             });
//           }}
//         >
//           <ValueSourceImage src={selected.imageUrl} />
//           <span> ({selected.value})</span>
//         </ValueSourceImageSelectedContainer>
//         {this.state.activated && (
//           <>
//             <ValueSourceDropdownOptions
//               onClose={() => {
//                 this.setState({
//                   activated: false
//                 });
//               }}
//             >
//               {this.props.options.map(o => (
//                 <div
//                   key={o.value}
//                   onClick={() => {
//                     if (o.value === selected.value) {
//                       return;
//                     }
//                     this.props.onChange(o.value);
//                   }}
//                 >
//                   <ValueSourceImage src={o.imageUrl} />
//                   <span> ({o.value})</span>
//                 </div>
//               ))}
//             </ValueSourceDropdownOptions>
//           </>
//         )}
//       </ValueSourceDropdownRoot>
//     );
//   }
// }
// interface ValueSourceDropdownOptionsProps {
//   readonly onClose: () => void;
// }
// class ValueSourceDropdownOptions extends React.Component<
//   ValueSourceDropdownOptionsProps,
//   {}
// > {
//   onClose = () => {
//     this.props.onClose();
//   };
//   componentDidMount() {
//     window.addEventListener("click", this.onClose);
//   }
//   componentWillUnmount() {
//     window.removeEventListener("click", this.onClose);
//   }
//   render(): JSX.Element {
//     return (
//       <ValueSourceDropdownOptionsContainer>
//         {this.props.children}
//       </ValueSourceDropdownOptionsContainer>
//     );
//   }
// }
//# sourceMappingURL=dropdown.js.map